/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo } from 'react';
import { FunctionComponent } from 'react';
import Loader from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { useApiRequestState } from '../../../utils/api.utils';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { QuartalForm } from '../../pages/common/forms/QuartalForm';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { IQuartalFormDialogProps } from './types';

export const QuartalFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();

  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'quartalFormDialog') as IQuartalFormDialogProps;
  const [showLoader, error] = useApiRequestState('createQuartal');

  const onClose = useCallback(() => {
    dispatch(closeDialog('quartalFormDialog'));
  }, [dispatch]);

  const title = useMemo(() => (props && props.quartalData ? 'Edit Quartal' : 'Add Quartal'), [props]);
  return (
    <ConnectedDialog dialogKey="quartalFormDialog">
      <div className="popup new_todo_popup" style={{ display: 'block' }}>
        <div className="panel" style={{ minWidth: '520px' }}>
          <div className="panel-header small-header flex jcsb">
            {title}

            <span className="close-popup close" onClick={onClose}>
              {!error && !showLoader && <i className="icon-close" />}
              {showLoader && <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />}
              {error && !showLoader && <p style={{ color: 'red' }}> Something went wrong </p>}
            </span>
          </div>
          <div className="panel-body" style={{ maxHeight: '619.1px' }}>
            <QuartalForm {...props} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="createQuartal" formName="quartal-form" text="Save" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
